if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            // Update legend text if it matches 'Select Color Option'
            const legend = this.modalContent.querySelector('fieldset.js legend.form__label');
            if (legend && legend.textContent.trim() === 'Select Color Option') {
              legend.textContent = 'Colors';
            }

            // **Initialize Yotpo Reviews here**
            if (window.yotpoWidgetsContainer) {
              yotpoWidgetsContainer.initWidgets();
            }

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}


// =============================== VARIANT URL UPDATE LOGIC FOR QUICK ADD CARDS  =======================================


document.addEventListener('DOMContentLoaded', () => {
  // Use a function to initialize a card
  const initCard = (card) => {
    const quickViewButton = card.querySelector('.block__quick-add__submit-btn');
    if (!quickViewButton) return;

    const variantInputs = card.querySelectorAll('input[data-variant-id]');
    if (!variantInputs.length) return;

    const updateProductUrl = (variantId) => {
      const baseUrl = quickViewButton.dataset.productUrl.split('?')[0];
      quickViewButton.setAttribute('data-product-url', `${baseUrl}?variant=${variantId}`);
      quickViewButton.setAttribute('data-variant-id', variantId);
      // console.log('Updated URL:', quickViewButton.dataset.productUrl);
    };

    variantInputs.forEach((input) => {
      input.addEventListener('change', () => updateProductUrl(input.dataset.variantId));
    });

    const checkedInput = card.querySelector('input[data-variant-id]:checked');
    if (checkedInput) updateProductUrl(checkedInput.dataset.variantId);
  };

  // Initialize all current cards
  document.querySelectorAll('.product-card-wrapper').forEach(initCard);

  // Observe for new cards (for Ajax/Infinite scroll)
  const container = document.querySelector('.collection-products') || document.body;
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.matches('.product-card-wrapper')) {
          initCard(node);
        } else if (node.nodeType === 1) {
          node.querySelectorAll('.product-card-wrapper').forEach(initCard);
        }
      });
    });
  });

  observer.observe(container, { childList: true, subtree: true });
});

